import { makeMapStateToProps, mapDispatchToProps } from "./map-to-props-factory";
import { createUniversalConnector } from "../../universal-connector-factory";
import { withSportsbookBetslipContext, type SportsbookBetslipContext } from "../../../context/sportsbook";
import { ComponentProps, StateProps, DispatchProps, ContainerProps } from "../props";

export default withSportsbookBetslipContext(
  ({ localization, capabilities, preferences }: SportsbookBetslipContext) => ({
    localization,
    capabilities,
    preferences,
  }),
)(
  createUniversalConnector<StateProps | false, DispatchProps, ContainerProps, ComponentProps>(
    makeMapStateToProps,
    mapDispatchToProps,
  ),
);
